import React, { Fragment } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AlertCircleOutline from "mdi-material-ui/AlertCircleOutline";

const AskOTPModal = ({ visible, close, onConfirm }) => {
  return (
    <Fragment>
      <Dialog
        open={visible}
        onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ className: "sp-modal__paper" }}
      >
        <DialogContent className="sp-modal sp-modal--left">
          <div className="sp-modal__head">
            <span className="sp-modal__icon">
              <AlertCircleOutline />
            </span>
            <h2 id="alert-dialog-title" className="sp-modal__title">
              A palavra-passe está incorreta.
            </h2>
          </div>
          <div id="alert-dialog-description" className="sp-modal__body">
            <small>
              A palavra-passe que introduziste está incorreta. Podes tentar novamente ou podes optar por receber um código de verificação por email para
              continuar.
            </small>
            <br />
            <br />
            <strong>Queres receber um código de verificação por email para continuar?</strong>
          </div>
        </DialogContent>
        <DialogActions className="sp-modal__actions">
          <button type="button" className="sp-modal__btn sp-modal__btn--ghost" onClick={close}>
            Não
          </button>
          <button type="button" className="sp-modal__btn sp-modal__btn--primary" onClick={onConfirm}>
            <strong>SIM, QUERO!</strong>
          </button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default AskOTPModal;
